function transform(_tagName, attribs) 
{
    const attributes = {
        tagName: 'script',
        attribs: { ...attribs },
    };

    if (attribs.type !== 'application/ld+json') 
    {
        return { value: false };
    }

    return attributes;
}

const allowedAttributes = ['type'];

export default {
    allowedAttributes,
    transform,
};
